import React from 'react'
import { useMediaQuery } from '@chakra-ui/react'

import { Laptop } from './components'

type MenuProps = {}

const Menu: React.FC<MenuProps> = ({}) => {
  const [isTabletOrMobile] = useMediaQuery(`(max-width: 55em)`)
  return isTabletOrMobile ? <></> : <Laptop />
}

export default Menu
